import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

const getMediaState = (state: RootState) => state.media;

export const selectRoomFiles = createSelector(
  [getMediaState],
  (mediaState) => mediaState.roomFiles
);

export const selectFeaturedContentFiles = createSelector(
  [getMediaState],
  (mediaState) => mediaState.featuredContentFiles
);

export const selectRoomFileCount = createSelector(
  [getMediaState],
  (mediaState) => mediaState.roomFileCount
);